import { render, staticRenderFns } from "./customContextMenu.vue?vue&type=template&id=2bf088a4&scoped=true"
import script from "./customContextMenu.vue?vue&type=script&lang=js"
export * from "./customContextMenu.vue?vue&type=script&lang=js"
import style0 from "./customContextMenu.vue?vue&type=style&index=0&id=2bf088a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf088a4",
  null
  
)

export default component.exports